import { render, staticRenderFns } from "./PostReplies.vue?vue&type=template&id=e6a1eb6e&"
import script from "./PostReplies.vue?vue&type=script&lang=js&"
export * from "./PostReplies.vue?vue&type=script&lang=js&"
import style0 from "./PostReplies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports